<template>
  <div class="chip">
    <div class="icon-wrapper">
      <button type="button" class="remove" @click.prevent="removeFeed" />
      <img
        :src="getTokenIconUrl(props.feed.replace('/USD', ''))"
        width="20"
        height="20"
        :alt="props.feed"
        class="icon"
      />
    </div>
    <div class="label">
      {{ props.feed }}
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  feed: String
})

const emits = defineEmits(['remove'])

const removeFeed = () => {
  emits('remove')
}
</script>

<style lang="scss" scoped>
.chip {
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 20px;
  background: var(--Banner-5, rgba(0, 0, 0, 0.05));
  padding: 7px 12px 7px 7px;
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: 0.13px;

  .label {
    padding-top: 2px;
  }
  &:hover {
    .icon {
      opacity: 0;
    }
    .remove {
      opacity: 1;
    }
  }
}

.icon-wrapper {
  position: relative;
  width: 20px;
  height: 20px;
  .icon {
    transition: opacity 0.4s;
    border-radius: 50%;
  }

  .remove {
    position: absolute;
    left: 0;
    top: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: var(--text, #000);
    opacity: 0;
    transition: opacity 0.4s;
    cursor: pointer;
    z-index: 9;

    &::after,
    &::before {
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      width: 10px;
      height: 2px;
      background: var(--white, #fff);
    }

    &::before {
      transform: translate(-50%, -50%) rotate(-45deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(45deg);
    }
  }
}
</style>
